import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { InfoUsuario } from '@utils';
import { View, Icon, Menu, Text, Dropdown } from '@components';
import pkg from '@package';

const DropdownStyled = styled(Dropdown)`
  cursor: pointer;
  align-items: center;
`;

const DownIcon = styled(Icon.DownOutlined)`
  color: white !important;
  font-size: 1em !important;
  margin-left: 5px;
`;

const InfoItem = styled(Menu.Item)`
  cursor: text !important;
  display: flex;
  flex-direction: column;

  span[name*=nome] {
    font-weight: bold;
  }
  span[name*=small] {
    color: rgba(0, 0, 0, 0.25);
    font-size: small;
  }
`;

const Informacoes = ({ infoUsuario }) => {
  if (!InfoUsuario.hasUser(infoUsuario)) return null;

  const menu = (
    <Menu>
      <InfoItem disabled>        
        <Text name="small">v{pkg.version}</Text>
      </InfoItem>
      <Menu.Divider />
      <Menu.Item type="danger">
        <Link to="/logout">
          Sair
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <DropdownStyled overlay={menu} trigger={['click']}>
      <View horizontal>
        <DownIcon />
      </View>
    </DropdownStyled>
  );
};

export default Informacoes;
